import { createPinia } from "pinia";
import { createApp } from "vue";

import "@/assets/styles/main.css";
import "virtual:vite-svg-2-webfont.css";

import App from "@/App.vue";
import { router } from "@/router";
import { useFeaturesStore } from "@/stores/features";

const pinia = createPinia();
const appContainer = document.getElementById("app");
if (appContainer !== null) {
  const app = createApp(App);

  app.use(pinia);
  app.use(router);
  void useFeaturesStore(pinia)
    .loadFeatures()
    .then(() => app.mount(appContainer));
}
